import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList  } from '@angular/core';
import { NovaGto } from '../../../base/vo/nova-gto';
import { Procedimentos } from '../../../base/vo/procedimentos';
import { AnexarImagensComponent } from '../../../anexar-imagens/anexar-imagens.component';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-generico-planos',
  templateUrl: './generico-planos.component.html',
  styleUrls: ['./generico-planos.component.css']
})
export class GenericoPlanosComponent implements OnInit {

  @Input() novaGto: NovaGto;
  @Output() novaGtoChange: EventEmitter<NovaGto> = new EventEmitter<NovaGto>();
  @ViewChildren('modalImagens') modalImagens: QueryList<AnexarImagensComponent>;

  displayExcluirProcedimento: boolean = false;
  subTituloModal: string = '';
  index: number;
  constructor() { }

  ngOnInit() {
  }
  
  //Abrir modal de imagens procedimento
  private abrirModalAnexarImagens(indice: number){
    this.modalImagens.toArray()[indice].show();
  }

  //Método para remover procedimento da lista.
  abrirModal(procedimento: Procedimentos, index){
    this.subTituloModal = index+1 + '. ' + procedimento.descricao;
    this.displayExcluirProcedimento = true;
    this.index = index;
  }

  removerProcedimento(){
    //remove o item da lista.
    let procedimento = this.novaGto.listaProcedimentos[this.index];
    this.removerImagensProcedimento(procedimento.linha);
    this.novaGto.listaProcedimentos.splice(this.index, 1); 
    if(this.novaGto.listaProcedimentos.length==0){
      this.novaGto.disabledTipoAtendimento = false;
    }
    this.novaGtoChange.emit(this.novaGto);
    this.displayExcluirProcedimento = false;
    this.subTituloModal = '';
    this.index = null;
  }
  
  removerImagensProcedimento(procedimentoTmpID:number){
  	if(this.novaGto.anexos && this.novaGto.anexos.length>0) {
  	  let indices = [];
  	  for(let i=0;i<this.novaGto.anexos.length;i++) {
        if(this.novaGto.anexos[i].linhaProcedimento == procedimentoTmpID) {
        	indices.push(i);
        }
  	  }
  	  
  	  if(indices.length>0) {
  	    for(let j=0;j<indices.length;j++) {
          this.novaGto.anexos.splice(indices[j], 1); 
  	    }
  	  }
  	}
  }

  fecharModal(){
    this.index = null;
    this.displayExcluirProcedimento = false;
    this.subTituloModal = '';
  }

  faces(facesList){
    var codigo = ''

    facesList.forEach(element => {
      codigo += element.codigo + ', ';
    });
    codigo = codigo.slice(0, -2);
    
    return codigo;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/components/nova-gto/planos-tratamento/generico-planos/generico-planos.component.ts